/* eslint-disable default-case */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import APP_STATUS from '@integrations/pint-appstore-commons/src/enums/APP_STATUS.json';
import { fetchStatusFrom } from '../appStatusActionCreators';
import { openSideloadedAppConfigurationModal } from '../../sideloadConfiguration/sideloadConfigurationActionCreators';
import { StatusSpan, AddButton, ConfigButton } from './appActionsItems';
import APPACTIONS_DISPLAY_VARIANT from '../../../enums/APPACTIONS_DISPLAY_VARIANT';

function AdminAppActions(props) {
    const isOnTile = props.variant === APPACTIONS_DISPLAY_VARIANT.APPS_LIST_ITEM;

    const configure = () => {
        props.dispatchFetchStatusForm(props.appId);
    };
    const configureSideloaded = () => {
        props.dispatchOpenSideloadedAppConfigurationModal({
            appId: props.appId,
            name: props.name,
        });
    };

    const sideloadedConfigButton = () => {
        const button = <ConfigButton text="Custom App Configuration" action={configureSideloaded} alias="laptop" />;

        return props.sideloaded && !isOnTile ? button : null;
    };

    const actionsSections = (statusSpanText) => (
        <div>
            <StatusSpan text={statusSpanText} />
            <ConfigButton action={configure} text="Settings" />
            {sideloadedConfigButton()}
        </div>
    );

    switch (props.status) {
        case APP_STATUS.ADDED_DOMAIN:
            return actionsSections('Added for all users');
        case APP_STATUS.ALLOWED_ADDED_USER:
        case APP_STATUS.ALLOWED:
            return actionsSections('Allowed for users');
        case APP_STATUS.ADDED_FOR_DOMAIN_GROUPS:
            return actionsSections('Added for groups');
        case APP_STATUS.DISABLED:
            return (
                <div>
                    <AddButton isAdmin isAvailable={props.isAvailable} action={configure} />
                    {sideloadedConfigButton()}
                </div>
            );
        default:
            return null;
    }
}

AdminAppActions.propTypes = {
    appId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    sideloaded: PropTypes.bool,
    isAvailable: PropTypes.bool,
    domainSettings: PropTypes.string,
    dispatchFetchStatusForm: PropTypes.func.isRequired,
    dispatchOpenSideloadedAppConfigurationModal: PropTypes.func.isRequired,
    variant: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
    dispatchFetchStatusForm: fetchStatusFrom,
    dispatchOpenSideloadedAppConfigurationModal: openSideloadedAppConfigurationModal,
};

export default connect(null, mapDispatchToProps)(AdminAppActions);
